import { UrlObject } from 'url';
import { ReactNode } from 'react';
import { twJoin } from 'tailwind-merge';
import Link from 'next/link';

interface Props {
    href?: string | UrlObject;
    onClick?: () => void;
    icon?: ReactNode;
    children: ReactNode;
    'aria-label'?: string;
}

export function ProfileMenuButton({ href, onClick, 'aria-label': ariaLabel, icon, children }: Props) {
    const className = twJoin(
        'flex-grow flex cursor-pointer text-nowrap rounded px-4 py-2.5 text-sm hover:bg-neutral-100',
    );

    return (
        <li className="flex">
            {href != null ? (
                <Link
                    className={className}
                    href={href}
                    role="menuitem"
                    tabIndex={0}
                    onClick={onClick}
                    aria-label={ariaLabel}>
                    {renderContent()}
                </Link>
            ) : (
                <button
                    type="button"
                    className={className}
                    role="menuitem"
                    tabIndex={0}
                    onClick={onClick}
                    aria-label={ariaLabel}>
                    {renderContent()}
                </button>
            )}
        </li>
    );

    function renderContent() {
        return (
            <span className="inline-flex items-center gap-2.5">
                {icon != null && icon}
                {children}
            </span>
        );
    }
}
